module.exports = __webpack_public_path__ + "static/img/01.bba2142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/01.jpg
// module id = 369
// module chunks = 1